<template>
    <table class="knob-jobs">
        <tbody>
            <tr v-for="(item, index) in items" :key="index" @click="openRightSheet(item)">
                <td class="date">{{ formats.shortDate(item.date) }}</td>
                <td class="knob"></td>
                <td class="description">
                    <ActivityFeedItem :item="item" :prefixExecutive="prefixExecutive" />
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import actions from '@/store/actions.js'
import { shortDate } from '@/utils/format'

import ActivityFeedItem from './ActivityFeedItem.vue'

export default {
    name: 'ActivityKnobJobs',
    components: {
        ActivityFeedItem,
    },
    data() {
        return {
            formats: {
                shortDate,
            },
        }
    },
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        prefixExecutive: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        openRightSheet(item) {
            this.$store.dispatch(actions.showActivityDetails, item.id)
        },
    },
}
</script>
<style>
.knob-jobs {
    border-collapse: collapse;
    table-layout: fixed;

    td {
        border: none;
        vertical-align: middle;
    }

    tr {
        cursor: pointer;
    }

    .date {
        color: var(--color-primary-500);
        font-size: var(--font-size-caption);
        padding: 16px 0px 16px 8px;
        font-weight: var(--weight-bold);
        line-height: 16px;
        width: 80px;
        white-space: nowrap;
        text-transform: uppercase;
    }

    td.knob {
        position: relative;
        width: 36px;
        background-image: url('~@/images/activity-knob-job/knob.svg');
        background-position: center;
        background-repeat: no-repeat;

        &::before,
        &::after {
            background-image: url('~@/images/activity-knob-job/pole.svg');
            background-position: center;
            background-repeat: repeat-y;
            content: ' ';
            display: block;
            left: 0;
            position: absolute;
            right: 0;
        }

        &::before {
            bottom: 50%;
            margin-bottom: 6px;
            top: 0;
        }

        &::after {
            bottom: 0;
            margin-top: 6px;
            top: 50%;
        }
    }

    tr:first-child {
        td.knob::before {
            display: none;
        }
    }

    tr:last-child {
        td.knob::after {
            display: none;
        }
    }

    td.description {
        padding: 8px 16px;
    }
}
</style>
